import React from "react";
import Carousel from 'react-slick';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import LocationOn from "@material-ui/icons/LocationOn";
import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";
import image1 from "assets/img/lowresportfolio-33.jpg";
import image2 from "assets/img/lowresportfolio-4.jpg";
import image3 from "assets/img/lowresportfolio-11.jpg";
import image4 from "assets/img/lowresportfolio-1.jpg";
import image5 from "assets/img/lowresportfolio-36.jpg";
import image6 from "assets/img/lowresportfolio-39.jpg";
import image7 from "assets/img/lowresportfolio-18.jpg";
import image8 from "assets/img/lowresportfolio-24.jpg";

export default class PortfolioSection extends React.Component {
  render() {
    const carouselSettings = {
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      easing: 'linear',
      pauseOnFocus: true,
    };

    const images = [image1, image2, image3, image4, image5, image6, image7, image8];

    return (
      <Carousel {...carouselSettings} className="portfolio-carousel">
        {images.map((value, index) => {
          return (
            <div>
              <img
                src={value}
                alt={"Slide " + index}
                className="slick-image"
                />
            </div>
          );
        })}
      </Carousel>
    );
  }
}